import React from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { displayValue, getDataValue, latestEntry, toFiniteNumber } from '../utils';

const Settings = {
  Name: 'Gauge',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'label', type: 'text', name: 'Label' },
      { id: 'dataId', type: 'text', name: 'Data path' },
      { id: 'min', type: 'number', name: 'Min', default: 0 },
      { id: 'max', type: 'number', name: 'Max', default: 100 },
      { id: 'unit', type: 'text', name: 'Unit' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const entry = latestEntry(DeviceData);
  const rawValue = getDataValue(entry, userSettings.dataId);
  const value = toFiniteNumber(rawValue);
  const min = toFiniteNumber(userSettings.min) ?? 0;
  const max = toFiniteNumber(userSettings.max) ?? 100;
  const range = max - min;
  const percentage = value === null || range <= 0 ? 0 : Math.max(0, Math.min(100, ((value - min) / range) * 100));

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>{userSettings.label || userSettings.dataId || 'Gauge'}</Typography>
        <Typography variant="body2">
          {displayValue(rawValue, userSettings.emptyText || 'Unknown')}{value !== null && userSettings.unit ? ` ${userSettings.unit}` : ''}
        </Typography>
      </Stack>
      <LinearProgress variant="determinate" value={percentage} sx={{ height: 10, borderRadius: 5 }} />
    </Box>
  );
};

export default {
  Settings,
  View,
};
